import { useEffect, useMemo, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule } from "ag-grid-community";

import "ag-grid-community/styles/ag-theme-quartz.css";

const modules = [AllCommunityModule];

const CAgGrid = ({
    rowData = [],
    columnDefs = [],
    loading = false,
    pagination = true,
    paginationPageSize = 10,
    rowSelection = "multiple",
    height = "500px",
    onRowClicked,
    defaultColDef = {},
}) => {

    const gridRef = useRef(null);

    // const mergedDefaultColDef = useMemo(
    //     () => ({
    //         sortable: true,
    //         filter: true,
    //         resizable: true,
    //         flex: 1,
    //         minWidth: 120,
    //         ...defaultColDef,
    //     }),
    //     [defaultColDef]
    // );

    const mergedDefaultColDef = useMemo(
    () => ({
        sortable: true,
        filter: true,
        floatingFilter: true,
        resizable: true,
        flex: 1,
        minWidth: 120,
        ...defaultColDef,
    }),
    [defaultColDef]
);

    useEffect(() => {
        if (!gridRef.current?.api) return;

        if (loading) {
            gridRef.current.api.showLoadingOverlay();
        } else {
            if (rowData.length === 0) {
                gridRef.current.api.showNoRowsOverlay();
            } else {
                gridRef.current.api.hideOverlay();
            }
        }
    }, [loading, rowData]);

    return (
        <div
            className="ag-theme-quartz mt-3"
            style={{ height, width: "100%" }}
        >
            <AgGridReact
                ref={gridRef}
                modules={modules}
                rowData={rowData}
                columnDefs={columnDefs}
                defaultColDef={mergedDefaultColDef}
                pagination={pagination}
                paginationPageSize={paginationPageSize}
                rowSelection={rowSelection}
                animateRows
                onRowClicked={onRowClicked}
                enableCellTextSelection
                ensureDomOrder
                suppressCellFocus={false}
                overlayLoadingTemplate="<span class='ag-overlay-loading-center'>Loading...</span>"
                overlayNoRowsTemplate="<span class='ag-overlay-loading-center'>No Records Found</span>"
            />
        </div>
    );
};

export default CAgGrid;